module.exports = __webpack_public_path__ + "img/Solomon Islands.5f98b526.svg";